module.exports = __webpack_public_path__ + "images/檀程长图04-03.jpg?v=576c4fc3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图04-03.jpg
 ** module id = 185
 ** module chunks = 1 2
 **/